import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

ReactDOM.render(
  <Auth0Provider
    domain="dev-gf77gd7d.us.auth0.com"
    clientId="aIsakjBFmeZd8UVgLOGMCQBk42G4u5Bo"
    redirectUri={window.location.origin}
  >
      <App />
  </Auth0Provider>,
  document.getElementById("root")
);